module.exports = Em.Component.extend({
    classNames: ['transaction-trail'],

    userOrganizations: Em.inject.service(),

    organization: Em.computed.oneWay('userOrganizations.activeOrganization'),

    originator: null,

    // Page the component is embedded on (e.g. 'invoice', 'bill') - passed in by the template, used for tracking only
    trackingContext: null,

    isLoaded: false,

    error: false,

    transactions: null,

    isDrawerOpen: 'false',

    selectedTransactionId: null,

    loadTransactions: function() {
        var self = this
        var originator = this.get('originator')
        Billy.Transaction.find({
            originatorReference: originator.get('reference'),
            sortProperty: 'transactionNo',
            withCreator: true
        }).promise
            .then(function(transactions) {
                self.set('transactions', transactions)
                    .set('isLoaded', true)
            }, function() {
                self.set('error', true)
            })
    }.on('didInsertElement'),

    actions: {
        openTransactionDrawer: function(transaction) {
            this.set('selectedTransactionId', transaction.get('id'))
            this.set('isDrawerOpen', 'true')
        }
    },

    customActions: {
        closeEmber: function() {
            this.set('isDrawerOpen', 'false')
        }
    }
})
